import { Dashboard, Payment } from '@/components';
import { PaymentOk } from './PaymentOk';

export const PaymentOkPage = () => (
  <Dashboard openLogIn>
    <PaymentOk />
  </Dashboard>
);
